import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Button,
  TextField,
  Divider,
} from "@mui/material";
import ReactToPrint from "react-to-print";
import { useQuery } from "@apollo/client";
import moment from "moment";
import { useDownloadExcel } from "react-export-table-to-excel";
import { ToWords } from "to-words";
//date picker
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
//Icons
import { SiMicrosoftexcel } from "react-icons/si";
import { BsPrinter } from "react-icons/bs";
//Srcs
import "../../Style/pagestyle.scss";
import { currencyFormat } from "../../Function/DynamicFn";
import school from "../../Assets/goglobal-school.png";
import symbol from "../../Assets/tacteing.jpg";
import LoadingPage from "../Include/LoadingPage";
import EmptyData from "../Include/EmptyData";
import { getKhmerMonthName, getKhmerYear } from "../../Function/DynamicFn";
import { GET_PAYMENT_BY_EXPIRED } from "../../Schema/Report";
import { SelectAcademicYear } from "../Include/DynamicSelect";
import {
  ConvertToEnglishWordsDollar,
  ConvertToKhmerWordsDollar,
} from "../Include/ReadCurrency";

export default function StudentPaymentEstimate() {
  const [fromDate, setFromDate] = useState(moment().startOf("day"));
  const [toDate, setToDate] = useState(moment());
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [khmerMonth, setKhmerMonth] = useState(getKhmerMonthName(fromDate));
  const [khmerYear, setKhmerYear] = useState(getKhmerYear(fromDate));
  let academicYearFromLocal = JSON.parse(
    window.localStorage.getItem("academicYearFromLocal")
  );

  const toWords = new ToWords({
    localeCode: "en-US",
    converterOptions: {
      currency: false,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: true,
    },
  });

  const [selectAcedemicVal, setSelectAcedemicVal] = useState(
    academicYearFromLocal
      ? academicYearFromLocal
      : {
        id: "",
        title: "",
      }
  );

  //Export to excel
  const [checkExport, setCheckExport] = useState(false);
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "student-payment-estimate",
    sheet: "student-payment-estimate",
  });
  const handleExportExcel = () => {
    setCheckExport(true);
    setTimeout(() => {
      onDownload();
      setCheckExport(false);
    }, 2000);
  };
  //  ================ Print PDF ===========================
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const componentRef = useRef(null);
  const reactToPrintContent = () => {
    return componentRef.current;
  };

  //======================================= GEt REport =====================================================

  const { refetch } = useQuery(GET_PAYMENT_BY_EXPIRED, {
    variables: {
      fromDate: fromDate ? moment(fromDate)?.format("YYYY-MM-DD") : null,
      toDate: toDate ? moment(toDate)?.format("YYYY-MM-DD") : null,
      academicYearId: selectAcedemicVal?.id,
    },
    onCompleted: ({ getPaymentByExpireDate }) => {
      // console.log("getPaymentByExpireDate::", getPaymentByExpireDate)
      setTableData(getPaymentByExpireDate);
      setLoading(false);
    },
  });

  useEffect(() => {
    if (fromDate && toDate) {
      refetch();
    }
  }, [fromDate, toDate, refetch]);

  useEffect(() => {
    if (selectAcedemicVal?.id) {
      window.localStorage.setItem(
        "academicYearFromLocal",
        JSON.stringify(selectAcedemicVal)
      );
    }
  }, [selectAcedemicVal?.id]);

  const reactToPrintTrigger = () => {
    return (
      <Button
        onClick={handleOpen}
        className="btn-create"
        startIcon={
          // <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
          <BsPrinter alt="CreateIcon" className="icon-add" />
        }
      >
        Print
      </Button>
    );
  };

  // console.log("tableData::", tableData)
  const totalPaidAmount = tableData
    ? tableData?.reduce((sum, row) => {
      return sum + (row?.paidAmount || 0);
    }, 0)
    : 0;

  const getAountAsWord = toWords.convert(
    parseFloat(totalPaidAmount?.toFixed(2))
  )
  // console.log("getAountAsWord::", getAountAsWord)
  const cutFirstLetter = getAountAsWord?.slice(0, 1)
  const remainWordLetter = getAountAsWord?.slice(1, 2000).toString()
  // console.log("getAountAsWord::", cutFirstLetter, remainWordLetter)

  const formatNumber = (number) => new Intl.NumberFormat().format(number);

  return (
    <div>
      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={2}>
          {/* <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Typography className="search-head-title">
              Search student's name
            </Typography>
            <TextField
              placeholder={t("search")}
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "#0f81c2" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid> */}
          <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Typography className="search-head-title">Academic Year</Typography>
            <SelectAcademicYear
              selectedVal={selectAcedemicVal}
              setSelectedVal={setSelectAcedemicVal}
              className="search-field"
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">From</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={fromDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setFromDate(newValue);
                  setKhmerMonth(getKhmerMonthName(newValue));
                  setKhmerYear(getKhmerYear(newValue));
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} sm={6} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">To</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={toDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setToDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={4.8} xl={4.8}>
            <Stack direction="row" justifyContent="right" spacing={1}>
              <Button
                className="btn-create"
                onClick={handleExportExcel}
                startIcon={
                  <SiMicrosoftexcel style={{ height: "18px", width: "18px" }} />
                }
              >
                Export
              </Button>
              <ReactToPrint
                content={reactToPrintContent}
                documentTitle={`student-payment-estimate`}
                removeAfterPrint
                trigger={reactToPrintTrigger}
              />

              {/* <ExportTuitionReport
            loading={loading}
            tableData={tableData}
            paginationData={paginationData}
            tableRef={tableRef}
          /> */}
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ marginTop: "20px" }} ref={componentRef}>
        <Box
          sx={{ bgcolor: "#fff", borderRadius: "10px" }}
          className="dibursement-print-container"
        >
          <Grid container>
            <Grid item xs={3}>
              <Stack direction="column">
                <img
                  src={school}
                  alt="school"
                  className="logo-size"
                // style={{ width: "100px" }}
                />
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Stack direction="column">
                <Stack justifyContent="center" alignItems="center">
                  <Typography className="disbursement-title-kh">
                    ព្រះរាជាណាចក្រកម្ពុជា
                  </Typography>
                  <Typography className="disbursement-title">
                    Kingdom Of Cambodia
                  </Typography>
                  <Typography className="disbursement-title-kh">
                    ជាតិ សាសនា ព្រះមហាក្សត្រ
                  </Typography>
                  <Typography className="disbursement-title">
                    Nation Region King
                  </Typography>
                  <img src={symbol} alt="" width="110px" />
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
          {/* <Stack direction="row" width="100%" justifyContent="right" spacing={3}>
            <Typography className="number-text">លេខ ៖</Typography>
            <Typography className="number-text">026 / 24</Typography>
          </Stack> */}

          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            marginTop="15px"
            spacing={0.5}
          >
            <Typography className="disbursement-table-title">
              តារាងព្យាករណ៍សិស្សបង់លុយប្រចាំខែ {khmerMonth}
            </Typography>
            <Typography className="disbursement-table-title">
              ឆ្នាំ {khmerYear}
            </Typography>
            <Typography className="disbursement-table-title-header">
              {/* កម្រិត​ Early Year Foundation Stage */}
            </Typography>
          </Stack>
          <Box sx={{ marginTop: "10px" }} justifyContent="center">
            <Box ref={tableRef}>
              <table style={{ width: "100%", display: "none" }}>
                <tr>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan={15} style={{ textAlign: "center" }}>
                    ព្រះរាជាណាចក្រកម្ពុជា
                  </td>
                </tr>
                <tr>
                  <td colSpan={15} style={{ textAlign: "center" }}>
                    Kingdom Of Cambodia
                  </td>
                </tr>
                <tr>
                  <td colSpan={15} style={{ textAlign: "center" }}>
                    ជាតិ សាសនា ព្រះមហាក្សត្រ
                  </td>
                </tr>
                <tr>
                  <td colSpan={15} style={{ textAlign: "center" }}>
                    Nation Region King
                  </td>
                </tr>
                <tr>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan={15} style={{ textAlign: "center" }}>
                    តារាងព្យាករណ៍សិស្សបង់លុយប្រចាំខែ ២០២៤-២០២៥
                  </td>
                </tr>
                <tr>
                  <td></td>
                </tr>
              </table>

              <table className="table-report-student-payment">
                <tr>
                  <th rowSpan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      ល.រ
                    </div>
                  </th>
                  <th rowSpan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      អត្តលេខ
                    </div>
                  </th>
                  <th rowSpan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      លេខវិក័យបត្រ
                    </div>
                  </th>
                  <th rowSpan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      ថ្ងៃផុតកំណត់
                    </div>
                  </th>
                  <th rowSpan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      កាល. បង់
                    </div>
                  </th>
                  <th rowSpan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      ឈ្មោះសិស្ស
                    </div>
                  </th>
                  <th rowSpan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      ភេទ
                    </div>
                  </th>
                  <th colspan="3">
                    <div className="table-report-receiving-voucher-khmer">
                      ថ្នាក់
                    </div>
                  </th>
                  <th rowSpan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      ប្រភេទនៃការបង់
                    </div>
                  </th>
                  <th colspan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      តម្លៃព្យាករណ៍
                    </div>
                  </th>
                  <th rowSpan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      ទឹកប្រាក់បានបង់ជាក់ស្តែង
                    </div>
                  </th>
                  <th rowSpan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      លេខទូរស័ព្ទ
                    </div>
                  </th>
                  <th rowSpan="2">
                    <div className="table-report-receiving-voucher-khmer">
                      ផ្សេងៗ
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    <div className="table-report-receiving-voucher-khmer">
                      អង់គ្លេស
                    </div>
                  </th>
                  <th>
                    <div className="table-report-receiving-voucher-khmer">
                      ខ្មែរ
                    </div>
                  </th>
                  <th>
                    <div className="table-report-receiving-voucher-khmer">
                      ទូទៅ
                    </div>
                  </th>
                  <th>
                    <div className="table-report-receiving-voucher-khmer">
                      ខែ
                    </div>
                  </th>
                  <th>
                    <div className="table-report-receiving-voucher-khmer">
                      ចំនួន
                    </div>
                  </th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th
                    style={{ backgroundColor: "#ffd4d4", color: "red" }}
                  >
                    $ {formatNumber(totalPaidAmount)}
                  </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
                {loading ? (
                  <tr>
                    <td colSpan={20} className="title-table-stat">
                      <LoadingPage />
                    </td>
                  </tr>
                ) : tableData?.length === 0 ? (
                  <tr>
                    <td colSpan={20} className="title-table-stat">
                      <EmptyData />
                    </td>
                  </tr>
                ) : (
                  <>
                    {tableData?.map((row, index) => {
                      console.log("row==>", row)
                      return (
                        <tr key={index}>
                          <td align="center">{index + 1}</td>
                          <td align="center">
                            {row?.studentId}
                          </td>
                          <td align="center">
                            {row?.invoiceId}
                          </td>
                          <td align="center">
                            {moment(row?.expiredDate).format("DD-MMM-yyyy")}
                          </td>
                          <td align="center">
                            {row?.paidDate === null ? "" : moment(row?.paidDate).format("DD-MMM-yyyy")}
                          </td>
                          <td>
                            <div className="table-report-receiving-voucher-khmer">
                              {row?.studentName}
                            </div>
                          </td>
                          <td align="center">
                            <div className="table-report-receiving-voucher-khmer">
                              {row?.gender}
                            </div>
                          </td>
                          <td align="center">
                            <div className="table-report-receiving-voucher-khmer">
                              {row?.foreignProgrammeClass
                                ? row?.foreignProgrammeClass
                                : "-"}
                            </div>
                          </td>
                          <td align="center">
                            <div className="table-report-receiving-voucher-khmer">
                              {row?.khmerProgrammeClass
                                ? row?.khmerProgrammeClass
                                : "-"}
                            </div>
                          </td>
                          <td align="center">
                            <div className="table-report-receiving-voucher-khmer">
                              {row?.generalProgrameClass
                                ? row?.generalProgrameClass
                                : "-"}
                            </div>
                          </td>
                          <td align="center">
                            {row?.typeOfPayment}
                          </td>
                          <td align="center">
                            {row?.countMonth}
                          </td>
                          <td align="center">
                            {/* $ {formatNumber(row?.paidAmount)} */}
                            $ {currencyFormat(row?.paidAmount)}
                          </td>
                          <td align="center">
                            {/* $ {formatNumber(row?.paidAmount)} */}
                             {row?.actualAmountPaid === 0 ? "" : `$ ${currencyFormat(row?.actualAmountPaid)}`}
                          </td>
                          {
                            row?.phoneNumberMother && row?.phoneNumberFather ? <td align="center">
                              {row?.phoneNumberMother} /{" "}
                              {row?.phoneNumberFather}
                            </td> : row?.phoneNumberMother ? <td align="center">
                              {row?.phoneNumberMother}
                            </td> : <td align="center">
                              {row?.phoneNumberFather}
                            </td>
                          }
                          <td>{row?.other}</td>
                        </tr>
                      );
                    })}
                  </>
                )}
              </table>

              <table style={{ width: "100%", display: "none" }}>
                <tr>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    នាយិការង
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }} colSpan={5}>
                    Deputy of School Principal
                  </td>
                  <td style={{ textAlign: "center" }} colSpan={5}>
                    ប្រធានកិច្ចការហិរញ្ញវត្ថុ
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }} colSpan={5}></td>
                  <td style={{ textAlign: "center" }} colSpan={5}>
                    Financial Affairs Director
                  </td>
                  <td style={{ textAlign: "center" }} colSpan={5}>
                    អ្នករៀបចំ
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }} colSpan={5}></td>
                  <td style={{ textAlign: "center" }} colSpan={5}></td>
                  <td style={{ textAlign: "center" }} colSpan={5}>
                    Prepare by
                  </td>
                </tr>
              </table>
            </Box>


            <Box sx={{ marginTop: "10px" }}>
              <Grid container spacing={0.5}>
                {/* <Grid item xs={2.5}>
                  <Typography className="number-text">
                    ចំនួនទឹកប្រាក់ជាអក្សរ ៖
                  </Typography>
                </Grid>
                <Grid item xs={9.5}>
                  <Typography className="number-text">
                    {ConvertToKhmerWordsDollar(totalPaidAmount)}
                  </Typography>
                </Grid>
                <Grid item xs={2.5}>
                  <Typography className="number-text">
                    Amount in words ៖
                  </Typography>
                </Grid>
                <Grid item xs={9.5}>
                  <Typography className="number-text">
                    {ConvertToEnglishWordsDollar(totalPaidAmount)}
                  </Typography>
                </Grid> */}

                <Grid item xs={12}>
                  <Stack direction="row" spacing={2}>
                    <Typography className="table-report-receiving-voucher-footer-khmer">
                      ចំនួនទឹកប្រាក់ជាអក្សរ
                    </Typography>
                    <Typography className="table-report-receiving-voucher-footer-khmer">
                      ៖ {ConvertToKhmerWordsDollar(totalPaidAmount)}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={2}>
                    <Typography className="table-report-receiving-voucher-footer-eng">
                      Amount in words
                    </Typography>
                    <Typography className="table-report-receiving-voucher-footer-eng">
                      <span className="table-report-receiving-voucher-footer-khmer">
                        ៖{" "}
                      </span>
                      <span className="table-report-receiving-voucher-footer-eng">{cutFirstLetter}</span>
                      <span className="number-text-lowercase">{remainWordLetter}</span> USD only
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ marginTop: "20px" }}>
              <Grid container>
                <Grid item xs={4}>
                  <Stack direction="column" alignItems="center">
                    <Typography className="disbursement-table-title">
                      នាយិការង
                    </Typography>
                    <Typography
                      className="table-report-receiving-voucher-footer-eng"
                    >
                      Deputy of School Principal
                    </Typography>
                    <Typography className="disbursement-table-title" mt={10}>
                      វេត ស្រីម៉ៅ
                    </Typography>
                    <Divider
                      style={{
                        width: "100px",
                        marginTop: "2px",
                        border: "1px solid rgba(15, 129, 194, 0.5)",
                      }}
                    />
                    <Typography className="table-report-receiving-voucher-footer-eng" mt={1}>
                      Date: .......................
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack direction="column" alignItems="center" mt={1}>
                    <Typography className="disbursement-table-title">
                      ប្រធាន
                    </Typography>
                    <Typography
                      className="table-report-receiving-voucher-footer-eng"
                    >
                      Director
                    </Typography>
                    <Typography className="disbursement-table-title" mt={10}>
                      ខូវ ស៊ូខេង
                    </Typography>
                    <Divider
                      style={{
                        width: "100px",
                        marginTop: "2px",
                        border: "1px solid rgba(15, 129, 194, 0.5)",
                      }}
                    />
                    <Typography className="table-report-receiving-voucher-footer-eng" mt={1}>
                      Date: .......................
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack direction="column" alignItems="center" mt={2}>
                    <Typography className="disbursement-table-title">
                      អ្នករៀបចំ
                    </Typography>
                    <Typography
                      className="table-report-receiving-voucher-footer-eng"
                    >
                      Prepare by
                    </Typography>
                    <Typography className="disbursement-table-title" mt={10}>
                      ស៊ុន ផាត់សន
                    </Typography>
                    <Divider
                      style={{
                        width: "100px",
                        marginTop: "2px",
                        border: "1px solid rgba(15, 129, 194, 0.5)",
                      }}
                    />
                    <Typography className="table-report-receiving-voucher-footer-eng" mt={1}>
                      Date: .......................
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
